import { render, staticRenderFns } from "./call-acc-template.vue?vue&type=template&id=f0810268"
import script from "./call-acc-template.vue?vue&type=script&lang=ts"
export * from "./call-acc-template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports